// Mobiles Sheet von unten: Ziehen am Griff nach unten schließt ab 80 px (DESIGN §3.7.1).
// Verschiebt das Panel direkt per Style (kein React-State pro Bewegung).
import { useRef, type PointerEvent, type RefObject } from 'react';

export const SWIPE_CLOSE_THRESHOLD = 80;

export function useSwipeToClose(
  panelRef: RefObject<HTMLElement | null>,
  onClose: () => void,
  enabled: boolean,
) {
  const start = useRef<number | null>(null);
  const offset = useRef(0);

  const reset = () => {
    const panel = panelRef.current;
    if (panel) {
      panel.style.transform = '';
      panel.style.transition = '';
    }
    start.current = null;
    offset.current = 0;
  };

  return {
    onPointerDown: (event: PointerEvent<HTMLElement>) => {
      if (!enabled || event.button !== 0) return;
      start.current = event.clientY;
      event.currentTarget.setPointerCapture?.(event.pointerId);
      if (panelRef.current) panelRef.current.style.transition = 'none';
    },
    onPointerMove: (event: PointerEvent<HTMLElement>) => {
      if (start.current === null || !panelRef.current) return;
      offset.current = Math.max(0, event.clientY - start.current);
      panelRef.current.style.transform = `translateY(${offset.current}px)`;
    },
    onPointerUp: () => {
      if (start.current === null) return;
      const close = offset.current > SWIPE_CLOSE_THRESHOLD;
      reset();
      if (close) onClose();
    },
    onPointerCancel: reset,
  };
}
